var _path, _path2, _path3, _circle, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductManagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21H4.5V18H6V16.5H4.5V12.75H6V11.25H4.5V7.5H6V6H4.5V3H18V15H19.5V3C19.5 2.175 18.825 1.5 18 1.5H4.5C3.675 1.5 3 2.175 3 3V6H1.5V7.5H3V11.25H1.5V12.75H3V16.5H1.5V18H3V21C3 21.825 3.675 22.5 4.5 22.5H12V21Z",
    fill: "#3A4861"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.53792 16.2922L9.35499 14.877L9.92603 13.8879L11.1282 14.582L10.5571 15.571L9.74006 16.9863L9.70536 16.6982L9.60169 15.8378L8.80469 16.1782L8.53792 16.2922Z",
    fill: "#3A4861",
    stroke: "#3A4861",
    strokeWidth: 1.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9822 16.9862L13.1651 15.571L12.5941 14.582L13.7962 13.8879L14.3673 14.877L15.1843 16.2922L14.9176 16.1782L14.1206 15.8378L14.0169 16.6982L13.9822 16.9862Z",
    fill: "#3A4861",
    stroke: "#3A4861",
    strokeWidth: 1.3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.7294,
    cy: 10,
    r: 4,
    fill: "white",
    stroke: "#3A4861",
    strokeWidth: 1.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 21.9425L14.0575 20L13 21.0575L16 24.0575L22 18.0575L20.9425 17L16 21.9425Z",
    fill: "#3A4861"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductManagement);
export default __webpack_public_path__ + "static/media/ProductManagement.c2e336df7a785e12d203a4bb39ef8ff8.svg";
export { ForwardRef as ReactComponent };